import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export default function ResponsiveDialog(props) {
  const { open, body, onClose, header, children, onConfirm, dtype } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClose = () => {
    onClose();
  };
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        {/* <DeleteIcon /> */}
        <DialogTitle id="responsive-dialog-title">{header}</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {body && (
              <Box className="modalBody">
                <Typography color="text.secondary">{body}</Typography>
              </Box>
            )}
          </DialogContentText>
          <DialogContentText>
            {children && (
              <Box className="modalBody">
                <Typography color="text.secondary">{children}</Typography>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {dtype === "msg" && (
            <Button autoFocus variant="contained" onClick={handleClose}>
              Okay
            </Button>
          )}
          {dtype === "confirm" && (
            <>
              <Button autoFocus variant="outlined" onClick={handleClose}>
                Cancle
              </Button>

              <Button variant="outlined" color="error" onClick={handleConfirm}>
                Delete
              </Button>
            </>
          )}
          {dtype === "permission" && (
            <>
              <Button autoFocus variant="outlined" onClick={handleConfirm}>
                Allow
              </Button>

              <Button variant="outlined" color="error" onClick={handleClose}>
                Not Allow
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
